export function notify({ message, notificationType = 'success', title = null, options = null, onlyOne = false }) {
    if (onlyOne) {
        toastr.remove();
    }
    let toastrFunc;
    switch (notificationType) {
        case 'success': toastrFunc = toastr.success; break;
        case 'danger': toastrFunc = toastr.error; break;
        case 'warning': toastrFunc = toastr.warning; break;
        default: toastrFunc = toastr.info; break;
    }
    toastrFunc(message, title, { timeOut: 5000, ...(options || {})});
}

export function generateRange(a, b = null, extremeValue = false) {
    let [min, max] = b === null ? [0, a] : [a, b];
    if (extremeValue) max++;
    return Array.from(new Array(max - min), (x, i) => i + min);
}

export function formatNumber(number) {
    return number.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
}

export function formatPrice(price, style = false, addSign = false) {
    if (price === null) return null;
    let currency = 'Ft';
    let sign = '';
    if (addSign) {
        if (price > 0) sign = '+';
        else if (price < 0) sign = '-';
        price = Math.abs(price);
    }
    price = formatNumber(price);
    if (style) {
        price = `<span class="strong">${price}</span>`;
        currency = `<span class="smaller">${currency}</span>`;
    }
    return (sign ? `${sign} ` : '') + `${price} ${currency}`;
}

export function sum(values) {
    return values.reduce((a, b) => a + b, 0);
}

export function avg(values) {
    return values.length > 0 ? sum(values) / values.length : 0;
}

export function cloneObj(obj) {
    return JSON.parse(JSON.stringify(obj));
}

export function getQueryParam(name) {
    return (new URLSearchParams(window.location.search)).get(name);
}
